import type { AppOperatingSystem } from "../../types/commonFiltersDto";
import type { AppsSearchFilterKey } from "../../types/misc";

/**
 * Centralized i18n key generators for apps-search-filters module.
 */
const appsSearchFiltersI18nKeys = {
    filterBase: (filterKey: AppsSearchFilterKey) => `si.apps_search.filters.${filterKey}`,

    filterTitle: (filterKey: AppsSearchFilterKey) => `${appsSearchFiltersI18nKeys.filterBase(filterKey)}.title`,
    filterTooltip: (filterKey: AppsSearchFilterKey) => `${appsSearchFiltersI18nKeys.filterBase(filterKey)}.tooltip`,

    appPlatformTaxonomy: (appOs: AppOperatingSystem) =>
        `${appsSearchFiltersI18nKeys.filterBase("market")}.${appOs}.text`,

    upgradeBanner: {
        title: "si.apps.filters.upgrade-banner.title",
        subtitle: "si.apps.filters.upgrade-banner.subtitle",
    } as const,
} as const;

export default appsSearchFiltersI18nKeys;
